export const colors = {
  background: 'transparent',
  primary: '#213743',
  secondary: '#3d5564',
  text: '#F2F7FF',
  purple: '#C52BFF',
  purpleDark: '#8D27B3',
} as const
